import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from '../../colors-ts';

/** The design's tooltip: black, small text, with an arrow (when used) in the same colour. */
export const tooltipOverrides: Components<Theme>['MuiTooltip'] = {
    styleOverrides: {
        tooltip: {
            borderRadius: '4px',
            backgroundColor: COLORS.black[700],
            fontSize: '12px',
            lineHeight: 1.5,
            // Rich content (e.g. help texts built from body1 Typography) takes the tooltip's size, not its own.
            '& .MuiTypography-root': {
                fontSize: 'inherit',
                lineHeight: 'inherit',
            },
        },
        arrow: {
            color: COLORS.black[700],
        },
    },
};
